/**
 * SWELLのサイドバー目次をスマホ時アコーディオン化する
 */
export const initTocAccordion = () => {
	const tocTtl = document.querySelector(".p-toc__ttl");
	const tocList = document.querySelector(".p-toc__list");

	if (!tocTtl || !tocList) return;

	// 初期状態のアクセシビリティ設定
	tocTtl.style.cursor = "pointer";
	tocTtl.setAttribute("aria-expanded", "false");

	tocTtl.addEventListener("click", () => {
		const isOpened = tocTtl.classList.contains("is-opened");

		// クラスの付け外し（CSS側でアニメーションを制御）
		tocTtl.classList.toggle("is-opened");
		tocList.classList.toggle("is-opened");

		// アクセシビリティ更新
		tocTtl.setAttribute("aria-expanded", !isOpened);
	});
};
